"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function getBadgeProps(title: string, categories?: {
  name: string;
}[]) {
  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes("flex") || lowerTitle.includes("tag")) {
    return {
      text: "Beliebt",
      className: "bg-primary text-white hover:bg-primary/90 border-transparent"
    };
  }
  if (lowerTitle.includes("fix") || lowerTitle.includes("monat")) {
    return {
      text: "Premium",
      className: "bg-secondary text-white hover:bg-secondary/90 border-transparent"
    };
  }
  if (categories && categories.length > 0) {
    return {
      text: categories[0].name,
      className: "bg-primary/10 text-primary hover:bg-primary/20 border-transparent"
    };
  }
  return null;
}
function TopicsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="179638" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={`skeleton-${i}`} data-index={i} className="border-none shadow-md rounded-[24px]">
            <AspectRatio ratio={16 / 9} className="bg-muted animate-pulse rounded-t-[24px]" />
            <CardContent className="p-8">
              <div className="h-6 w-24 bg-muted animate-pulse rounded-full mb-4" />
              <div className="h-8 w-full bg-muted animate-pulse rounded-md mb-2" />
              <div className="h-8 w-2/3 bg-muted animate-pulse rounded-md mt-auto" />
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error || posts.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.slice(0, 3).map((post, i) => {
      const badge = getBadgeProps(post.title, post.categories);
      return <Card key={post.id} data-index={i} className="group flex flex-col overflow-hidden border border-[#D1D5DB] bg-white rounded-[24px] shadow-sm transition-all duration-300 hover:scale-[1.02] hover:shadow-xl">
            <AspectRatio ratio={16 / 9} className="overflow-hidden">
              <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603628/img/swiss_infrastructure_tech_fallback.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </AspectRatio>
            <CardContent className="flex flex-1 flex-col items-start p-8">
              {badge && <Badge className={`mb-4 rounded-full px-4 py-1 text-xs font-semibold ${badge.className}`}>
                  {badge.text}
                </Badge>}
              <h3 className="mb-6 line-clamp-3 text-xl font-bold text-[#212121] tracking-tight">
                {post.title}
              </h3>
              <div className="mt-auto pt-2 w-full">
                <Link to="#" className="group/link inline-flex w-full items-center justify-center rounded-full bg-primary px-6 py-3 text-sm font-bold text-white transition-all duration-300 hover:bg-primary/90 hover:shadow-md">
                  Jetzt buchen
                  <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                </Link>
              </div>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function CurrentTopics() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}